import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  HowToVote as VoteIcon,
  BarChart as ResultsIcon,
  People as PeopleIcon,
  Dashboard as DashboardIcon,
  QueryStats as ForecastIcon,
  Timeline as TimelineIcon,
  Insights as InsightsIcon,
  CompareArrows as CompareIcon,
  Description as ManifestoIcon,
  AccessTime as CountdownIcon,
  RssFeed as RssFeedIcon,
  AccountBalance as ActorsIcon,
  Hub as NetworkIcon,
} from '@mui/icons-material';
import { useUserRole } from '../../contexts/UserRoleContext';

export interface MenuItemType {
  text: string;
  icon: React.ReactNode;
  path?: string;
  badge?: string;
  children?: MenuItemType[];
}

export const useNavItems = (): MenuItemType[] => {
  const { t } = useTranslation();
  const { hasFeature } = useUserRole();

  return [
    { text: t('nav.overview'), icon: <DashboardIcon />, path: '/' },
    {
      text: t('nav.electionInfo'),
      icon: <VoteIcon />,
      children: [
        { text: t('nav.candidates'), icon: <PeopleIcon />, path: '/candidates' },
        { text: t('nav.compare'), icon: <CompareIcon />, path: '/compare' },
        { text: t('nav.manifestos'), icon: <ManifestoIcon />, path: '/manifestos' },
        ...(hasFeature('vote') ? [{ text: t('nav.voters'), icon: <VoteIcon />, path: '/voters', badge: t('nav.voteNow') }] : []),
      ],
    },
    {
      text: t('nav.liveCenter'),
      icon: <TimelineIcon />,
      children: [
        { text: t('nav.elections'), icon: <CountdownIcon />, path: '/elections' },
        { text: t('nav.liveResults'), icon: <ResultsIcon />, path: '/results' },
      ],
    },
    ...(hasFeature('data_insights') ? [{ text: t('nav.dataInsights'), icon: <InsightsIcon />, path: '/data-insights' }] : []),
    { text: 'Forecast', icon: <ForecastIcon />, path: '/forecast' },
    { text: 'Networks', icon: <NetworkIcon />, path: '/networks' },
    { text: 'Political Actors', icon: <ActorsIcon />, path: '/political-actors' },
    { text: t('nav.newsSocial'), icon: <RssFeedIcon />, path: '/news' },
  ];
};
